module.exports = __webpack_public_path__ + "img/img-search05.2b68e0a1.jpg";